import EventEmitter2 from "eventemitter2";

const eventBus = new EventEmitter2();

export default eventBus;